import nwApi from '../nwApi'

export default function (param) {
    nwApi.common('windowConfig',param)
}